//components
import React, { useEffect, useState } from 'react';
import CustomModal from '../../components/modal';
import ImageGallery from '../../components/imageGallery';
import { themePropType } from '../../components/sharedPropTypes';
import { getImagePaths, loadImages } from '../../utils/imageLoader';

const CardThings = ({ theme }) => {
    const [selectedImage, setSelectedImage] = useState(null);
    const [cardImages, setCardImages] = useState([]);

    //For dynamic imports (better for code splitting)
    useEffect(() => {
      const loadCollectionImages = async () => {
        const images = await loadImages('cardThings');
        setCardImages(images);
      };
      loadCollectionImages();
    }, []);

    return (
      <div className='cardThingsPage'>
        <h3>Card Things</h3>
        <p>I'm gonna count both trading cards, card I get from collectibles, parts of boxes I cut out from collectibles, and plushie tags I find interesting as card things.</p>
        <ImageGallery
          images={cardImages}
          onImageClick={setSelectedImage}
        />
        <CustomModal
          isOpen={!!selectedImage}
          onRequestClose={() => setSelectedImage(null)}
          theme={theme}
        >
          {selectedImage && (
            <img 
              src={selectedImage} 
              style={{ maxWidth: '100%', maxHeight: '80vh' }} 
              alt="Enlarged cards" 
            />
          )}
        </CustomModal>
      </div>
    );
  };
  
  export default CardThings;